import React from 'react';
import FeatureFlag from 'components/shared/FeatureFlag';
import useFeatureFlags from 'hooks/useFeatureFlags';

const VersionOneSecondaryRoleOptions = () => (
  <ul>
    <li>
      {t('settings.tab.roles.edit.people_management_view_activity_label')}
    </li>
    <li>
      {t('settings.tab.roles.edit.people_management_deploy_content_label')}
    </li>
    <li>{t('settings.tab.roles.edit.people_management_grade_label')}</li>
    <FeatureFlag features={['readiness-enable-lesson-mark-as-complete']}>
      <li data-testid="mark-as-complete-manage-groups">
        {t('settings.tab.roles.edit.mark_as_complete.manage_groups')}
      </li>
    </FeatureFlag>
    <FeatureFlag features="skills">
      <li>
        {t(
          'settings.tab.roles.edit.people_management_skills_complete_assessment_label',
        )}
      </li>
      <li>
        {t(
          'settings.tab.roles.edit.people_management_skills_request_assessment_and_coaching_plan_label',
        )}
      </li>
      <li>
        {t(
          'settings.tab.roles.edit.people_management_skills_export_report_label',
        )}
      </li>
    </FeatureFlag>
  </ul>
);

const VersionTwoSecondaryRoleOptions = () => (
  <ul>
    <li>
      {t('settings.tab.roles.edit.people_management_view_activity_label')}
    </li>
    <li>
      {t('settings.tab.roles.edit.people_management_deploy_content_label')}
    </li>
    <li>{t('settings.tab.roles.edit.people_management_grade_label')}</li>
    <FeatureFlag features={['readiness-enable-lesson-mark-as-complete']}>
      <li data-testid="mark-as-complete-manage-groups">
        {t('settings.tab.roles.edit.mark_as_complete.manage_groups')}
      </li>
    </FeatureFlag>
    <FeatureFlag features="skills">
      <li>
        {t(
          'settings.tab.roles.edit.people_management_skills_complete_assessment_label',
        )}
      </li>
    </FeatureFlag>
  </ul>
);

const ManagementGroupByGroupBasis = () => {
  const hasSkillsEnabled = useFeatureFlags([
    'readiness-enable-skills-2-0',
    'skills',
  ]);

  return hasSkillsEnabled ? (
    <VersionTwoSecondaryRoleOptions />
  ) : (
    <VersionOneSecondaryRoleOptions />
  );
};

export default ManagementGroupByGroupBasis;
